import { H3 } from '@berlitz/globals'
import Search from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/25-Search/SearchAlternate'
import Button from '@components/Button'
import Select from '@components/Select'
import styled, { css } from 'styled-components'

export const DesktopFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .ant-select {
    width: 157px;
  }

  .ant-dropdown-menu {
    max-height: 215px;
    overflow: scroll;
  }
`

export const Filter = styled.div`
  ${({ theme }) => css`
    width: 157px;
    margin-right: ${theme.space.sm};
    margin-bottom: ${theme.space.md};
    .micro-multi-select-dd {
      border: none;
    }

    &:first-child {
      & > div {
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }
  `}
`

export const FieldLabel = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  padding-bottom: ${({ theme }) => theme.space.xs};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledBtn = styled(Button)`
  background-color: ${({ theme }) => theme.colors.brandPrimaryContrast};
`

export const StyledFindLesson = styled.div`
  ${({ theme }) => css`
    width: 190px;
    text-align: center;
    padding: ${theme.space.sm + ' ' + theme.space.xs};
    background-color: ${theme.palette.blue10};
    border-radius: ${theme.radius.sm};
    font-size: ${theme.fontSize.xxs};

    & > div:first-child {
      padding-bottom: ${theme.space.xs};
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
      display: flex;
      align-items: center;

      ${StyledBtn} {
        white-space: nowrap;
        padding: 6px 20px;
      }

      & > div:first-child {
        width: 100%;
        text-align: left;
        font-size: ${theme.fontSize.xxs};
        line-height: 1.14;
        letter-spacing: 0.49px;
        padding-bottom: 0;
      }
    }
  `}
`

export const Flex = styled.div`
  display: flex;
`

export const LeftContent = styled.div`
  width: 100%;
`

export const RightContent = styled.div`
  margin-left: auto;
`

export const SearchIcon = styled(Search)`
  position: absolute;

  ${({ theme }) => css`
    right: ${theme.space.sm};
    color: ${theme.palette.charcoal};
    font-size: ${theme.fontSize.xs};
  `}
`

export const SearchFilter = styled.div<{ readOnly?: boolean }>`
  margin-left: auto;
  ${({ theme, readOnly }) => css`
    margin-right: ${readOnly ? '0' : theme.space.xl};
    margin-bottom: ${theme.space.md};
  `}

  @media (max-width: 1112px) {
    margin-left: unset;
  }
`

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  input {
    border: 1px solid ${({ theme }) => theme.palette.gray100};
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    padding: 7px 36px 7px 6px;
    width: 256px;
  }
`

export const SearchHeader = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
      flex-flow: column;
      gap: ${theme.space.md};

      ${SearchDetails} {
        width: 100%;

        ${Tag}, span:last-child {
          margin-left: auto;
        }
      }

      ${SortWrapper} {
        width: 100%;
        margin-left: unset;

        ${SortSelect}, [aria-busy="true"]:last-child, [aria-busy="true"]:last-child > .react-loading-skeleton {
          width: 100% !important;
          margin-right: 0;
        }
      }
    }
  `}
`

export const SortSelect = styled(Select)`
  min-width: 200px;
`

export const SearchDetails = styled.div`
  display: flex;
  align-items: center;
`

export const SortWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;

  ${({ theme }) => css`
    & > span:first-child {
      font-size: ${theme.fontSize.xxs};
      font-weight: ${theme.fontWeight.bold};
      margin-right: ${theme.space.xs};
    }
  `}
`

export const Tag = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.brandPrimary};
    color: ${theme.colors.brandPrimaryContrast};
    padding: ${theme.space.xxs + ' ' + theme.space.md};
    border-radius: 10px;
    height: max-content;
    font-size: ${theme.fontSize.xxxs};
    font-weight: ${theme.fontWeight.bold};
  `}
`

export const StyledH3 = styled(H3)`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-right: ${({ theme }) => theme.space.xs};
  margin-bottom: 0;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(550px, 1fr));

  ${({ theme }) => css`
    grid-gap: ${theme.space.md};
    & > div {
      background-color: white;
      overflow: hidden;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
    }

    @media (min-width: ${theme.breakpoints.xl}) {
      grid-template-columns: repeat(2, 1fr);
    }
  `}
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EmptyResultWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    font-size: ${theme.fontSize.sm};
    line-height: 1.56;
    letter-spacing: 0.63px;
    font-weight: ${theme.fontWeight.bold};
    text-align: center;
  `}
`

export const ResultsWrapper = styled.div`
  min-height: 500px;
  .single-neutral_svg__circle0 {
    fill: currentColor;
  }

  img[hidden] {
    display: none;
  }
`

export const EmptyInstructorsWrapper = styled(EmptyResultWrapper as any)`
  flex-flow: row;
  text-align: left;
  img {
    min-height: 85px;
  }

  ${({ theme }) => css`
    & > div {
      margin-right: ${theme.space.md};
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      flex-flow: column;
      text-align: center;
      padding-bottom: ${theme.space.xs};
      img {
        height: 115px;
      }

      & > div:last-child {
        max-width: 300px;
      }
    }
  `}
`

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  overflow: hidden;
`

export const AvatarName = styled.div<{ isEditMode?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: underline;
  flex-flow: column;
  cursor: ${({ isEditMode }) => (isEditMode ? 'default' : 'pointer')};

  & > div {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 86px;
    white-space: nowrap;
  }

  ${({ theme }) => css`
    width: 86px;
    color: ${theme.colors.brandPrimary};
    line-height: 1.14;
    font-size: ${theme.fontSize.xxs};
    font-weight: ${theme.fontWeight.bold};
  `}
`

export const CarouselWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.space.sm};
  border-top: 1px solid transparent;
`

export const ScrollView = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space.sm};
  overflow-x: auto;
  overflow-y: clip;
  scroll-behavior: smooth;
`

export const Controls = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ControlWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.xs};
  margin-left: auto;
`

export const ControlBtn = styled.div<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    padding: 9px ${theme.space.xs};
    background-color: ${disabled ? theme.palette.gray20 : theme.colors.brandPrimary};
    border-radius: 3px;
    svg {
      color: ${disabled ? theme.palette.gray100 : theme.colors.brandPrimaryContrast};
      width: 16px;
      height: 16px;
    }
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
  `}
`

export const DesktopView = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.sm}) {
      display: none;
    }
  `}
`

export const MobileView = styled.div`
  display: none;
  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.sm}) {
      display: flex;
      flex-flow: column;
    }
  `}
`

export const MFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.xs};
`

export const MInputWrapper = styled(SearchBar as any)<{ show?: boolean }>`
  ${({ show, theme }) => css`
    display: ${show ? 'flex' : 'none'};
    position: relative;
    input {
      width: 100%;
    }
    & > div {
      width: 100%;
    }
    margin-bottom: ${theme.space.md};
  `}
`

export const MobileFilterBtn = styled(Button)`
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
`

export const MobileSearchBtn = styled(Button)`
  ${({ theme, show }) => css`
    display: ${show ? 'flex' : 'none'};
    background-color: ${theme.colors.brandPrimaryContrast};
    padding: 9px ${theme.space.sm};
    svg {
      font-size: ${theme.fontSize.xs};
    }
  `}
`

export const MISearchBtn = styled(Button)`
  ${({ theme }) => css`
    padding: 9px ${theme.space.sm};
    position: absolute;
    right: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    svg {
      font-size: ${theme.fontSize.xs};
      color: ${theme.colors.brandPrimaryContrast};
    }
  `}
`

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    padding-top: ${theme.space.xs};
    & > div {
      width: 100%;
    }

    & > div > span > div {
      display: flex;
      align-items: center;
      font-size: ${theme.fontSize.xs};
    }
  `}
`

export const AvatarIconWrapper = styled.div`
  position: relative;
`

export const DeleteIcon = styled.div`
  width: max-content;
  height: max-content;
  border-radius: ${({ theme }) => theme.layout.xxl};
  background-color: white;
  color: ${({ theme }) => theme.palette.danger100};
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.palette.danger100};
    width: 24px;
    height: 24px;
  }
`

export const LoaderWrapper = styled.div`
  width: calc(100% - 20px);
  height: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: calc(100% - 120px);
    height: calc(100% - 50px);
  }
`

export const SpinnerWrapper = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  background: white;
  justify-content: center;
`

export const ForbiddenBox = styled.div`
  ${({ theme }) => css`
    max-width: 600px;
    width: 100%;
    font-size: ${theme.fontSize.sm};
    font-weight: ${theme.fontWeight.bold};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: 0.63px;
    text-align: center;
    margin: auto;
  `}
`
